"use client";

import { LanguageContext } from "@/context/languageContext";
import { PopupContext } from "@/context/popupContext";
import styles from "@/styles/modules/components/popup.module.scss";
import { translate } from "@/utils/translate";
import Image from "next/image";
import { FormEvent, useContext } from "react";

export default function Popup() {
  const { language } = useContext(LanguageContext);
  const { isPopupOpen, closePopup } = useContext(PopupContext);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
  };

  return (
    <section className={`${styles.popup} ${isPopupOpen ? "" : styles.closed}`}>
      <div className={styles.popupContainer}>
        <Image
          src="/images/imperial-logo.svg"
          alt="Imperial Riding School logo"
          width="116"
          height="85"
          priority
        />
        <h1>{translate["popupTitle"][language]}</h1>
        <p>{translate["popupText"][language]}</p>
        <form onSubmit={handleSubmit}>
          <div className={`${styles.formItem} ${styles.half}`}>
            <input
              type="text"
              id="name"
              name="name"
              placeholder={translate["firstName"][language]}
              required
              autoComplete="on"
            />
          </div>
          <div className={`${styles.formItem} ${styles.half}`}>
            <input
              type="text"
              id="lastname"
              name="lastname"
              placeholder={translate["lastName"][language]}
              required
              autoComplete="on"
            />
          </div>
          <div className={styles.formItem}>
            <input
              type="email"
              id="email"
              name="email"
              placeholder={translate["emailMayus"][language]}
              required
              autoComplete="on"
            />
          </div>
          <div className={styles.formItem}>
            <input type="submit" value={translate["signUp"][language]} />
          </div>
        </form>
        <span className={styles.closeIcon}>
          <Image
            alt="Close icon"
            src="/icons/close-icon.svg"
            width={41}
            height={31}
            onClick={closePopup}
          />
        </span>
      </div>
    </section>
  );
}
